<template id="editable-column-content">
  <div>
    <div >
      <el-checkbox
        v-model="scope.row[property]" @blur="run"
        @keyup.enter="$emit('enter-input')">
      </el-checkbox>
    </div>
  </div>
</template>
<script>
  import {Checkbox} from 'element-ui';
  export default {
    name: "editableColumn",
    components:{
      [Checkbox.name]: Checkbox,
    },
    props: ['is-editing', 'scope', 'editing', 'on-blur', 'on-enter', 'property'],
    methods:{
      run(){
        this.$emit('blur-input', {field: this.property, index: this.scope.$index, value: this.scope.row});
        // this.ociLog("run");
        // this.ociLog(this.scope.$index);
        // this.ociLog({field: this.property, index: this.scope.$index, value: this.scope.row[this.property]});
      }
    },
    mounted() {
      // this.ociLog("property============");
      // this.ociLog(this.property);
    },
    directives: {
      focus: {
        // directive definition
        inserted: function (el) {
          el.focus()
        }
      }
    }
  }

</script>

<style scoped>

</style>
